import ScrollReveal from "scrollreveal";

const scrollReveal = ScrollReveal();

function getInlineConfig(el) {
    const { scrollRevealConfig } = el.dataset;
    return scrollRevealConfig && JSON.parse(scrollRevealConfig);
}

function initScroll(el, options) {
    if (el.classList.contains(".mix") && el.style.display === "none") {
        // This will stop mixitup hidden elements (with class 'mix') being show by scroll-reveal when hidden;
        return;
    }
    scrollReveal.reveal(el, getInlineConfig(el) || options);
}

export default {
    init: () => {
        // Generic reveal
        document.querySelectorAll(".scroll-reveal").forEach(initScroll);

        document.querySelectorAll(".staff_member").forEach(initScroll);

        document
            .querySelectorAll(".mix:not(.scroll-reveal")
            .forEach(function (el) {
                initScroll(el, {
                    mobile: false,
                    interval: 0,
                    delay: 90,
                    distance: "20px",
                    duration: 910,
                    origin: "top",
                    scale: 1,
                    easing: "cubic-bezier(.46,.79,.61,.8)",
                    viewOffset: {
                    bottom: 300
                  }
                });
            });
    },
    cleanup: () => ScrollReveal().destroy()
};
